import { GraphQlClient } from '@intelipost-js/secure-providers';


export default {
  getRules(context, token) {
    return GraphQlClient.query(`
    query {
      client_user_rules {
        passwordMinLength
        rules {
          ruleDescription
          regex
        }
      }
    }`, { token })
    .then((res) => {
      const {
        data,
      } = res;
      const {
          client_user_rules,
      } = data;
      const {
          rules,
          passwordMinLength,
      } = client_user_rules;

      return Promise.resolve({
        rules,
        passwordMinLength,
      });
    });
  },
};



// WEBPACK FOOTER //
// ./src/stores/client-rules-password/actions.js